import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./assets/css/custom.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import Pusher from "pusher-js";

export const pusher = new Pusher("77fe47d0e249770c7d32", {
  cluster: "eu",
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

serviceWorker.unregister();
